export interface ChecklistItem {
  id: string;
  title: string;
  description: string;
}

export const checklistItems: ChecklistItem[] = [
  { id: '1', title: 'Payload loaded', description: 'Confirm the payload is attached' },
  { id: '2', title: 'Payload secured', description: 'Ensure it\'s firmly fastened' },
  { id: '3', title: 'Flight authorized', description: 'Verify approval/permission' },
  { id: '4', title: 'Propellers secure', description: 'Check blades are tightened' },
  { id: '5', title: 'Clear radius', description: 'No obstacles within 10 ft.' },
  { id: '6', title: 'Safe distance', description: 'Stand 10 ft from drone' },
];

export const GAMEPAD_MESSAGE = 'CONNECT YOUR GAMEPAD AND PRESS BUTTONS TO BEGIN';
export const AGREEMENT_TEXT = 'Agree and confirm all items in checklist';
export const SIDEBAR_TITLE = '5. Preflight checklist';

